var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alphaKeys base-button"},[_c('div',[_vm._t("alphaName")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }